import { CSSProperties } from 'react';
import styled from 'styled-components';

interface IProps {
    color: string;
    contents: string;
    className?: string;
    fontStyle: CSSProperties;
    direction?: string;
}

function Balloon({ color, contents, className, fontStyle, direction = 'right' }: IProps) {
    return (
        <Container className={className} color={color} fontStyle={fontStyle}>
            {direction === 'up' && <div className="arrow-up" />}
            {direction === 'left' && <div className="arrow-left" />}
            <div className="contents">{contents}</div>
            {direction === 'right' && <div className="arrow-right" />}
            {direction === 'down' && <div className="arrow-down" />}
        </Container>
    );
}

const Container = styled.div<{ color: string; fontStyle: CSSProperties }>`
    position: relative;
    border-radius: 8px;
    //padding: 8px 3px 8px 3px;

    /* box-shadow: 2px 4px 6px rgba(0, 0, 0, 0.06); */

    .contents {
        padding: 3px 8px;
        background-color: ${({ color }) => color};
        border-radius: 8px;
        ${({ fontStyle }) => ({ ...fontStyle })}
    }
    .triangle {
        width: 0;
        height: 0;
        border-top: ${({ color }) => `9.5px solid ${color}`};
        border-left: 0px solid transparent;
        border-right: 10px solid transparent;
        position: absolute;
        right: 10px;
    }
    .arrow-right {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;

        border-left: ${({ color }) => `12px solid ${color}`};
        position: absolute;
        right: -8px;
        top: 4px;
    }

    .arrow-left {
        width: 0;
        height: 0;
        border-top: 10px solid transparent;
        border-bottom: 10px solid transparent;

        border-right: ${({ color }) => `12px solid ${color}`};
        position: absolute;
        left: -7px;
        top: 3px;
    }
    .arrow-up {
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;

        border-bottom: ${({ color }) => `10px solid ${color}`};
        position: relative;
        /* bottom: 0px; */
        /* top: -100px; */
        left: 50%;
        margin-left: -5px;
    }

    .arrow-down {
        width: 0;
        height: 0;
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;

        border-top: ${({ color }) => `10px solid ${color}`};
        position: relative;
        /* bottom: 0px; */
        /* top: -100px; */
        left: 50%;
        margin-left: -5px;
    }
`;

export default Balloon;
